import { TranslationType } from '../../util/i18n';
import {
  TypeContext,
  getEcoRating,
  getEmissionData,
  getEmissionFootnotesMap,
  getEngineDescriptionDls,
  getFinalInspectionDate,
  getFuelType,
  getGearbox,
  technicalDataConfigurationForMarkets,
} from '../VehicleTechnicalDataUtils';

import { InflateRequestMode } from '@sccs/types';
import { OptionalProductDto } from '../../types/dls/dls-response/ProductDto';
import { type ParsedTechnicalData } from '../VehicleTechnicalDataUtils';

export const technicalDataParserDls = (
  product: OptionalProductDto,
  market: string,
  language: string,
  mode: InflateRequestMode,
  translations: (key: string, dataset?: TranslationType) => string,
) => {
  const getConfiguredTechnicalData = (): Partial<ParsedTechnicalData> => {
    const parsedTechnicalData: Partial<ParsedTechnicalData> = {};

    const addIfConfiguredForMarket = (key: keyof ParsedTechnicalData, getValue: () => any) => {
      if (technicalDataConfigurationForMarkets(key, market, TypeContext.DLS)) {
        parsedTechnicalData[key] = getValue();
      }
    };

    addIfConfiguredForMarket('engineDescription', () => getEngineDescriptionDls(product, translations));
    addIfConfiguredForMarket('fuelType', () => getFuelType(product, TypeContext.DLS));
    addIfConfiguredForMarket('gearBox', () => getGearbox(product, TypeContext.DLS));
    addIfConfiguredForMarket('finalInspectionDate', () => getFinalInspectionDate(product, mode, TypeContext.DLS));
    addIfConfiguredForMarket('ecoRating', () => getEcoRating(product, language));
    addIfConfiguredForMarket('emissionData', () =>
      getEmissionData(product, TypeContext.DLS, language, translations, market),
    );
    addIfConfiguredForMarket('emissionFootnotes', () => getEmissionFootnotesMap(product));
    return parsedTechnicalData;
  };

  return {
    getTechnicalData: getConfiguredTechnicalData,
  };
};
export { ParsedTechnicalData };
